import {
    buttonActionFunc
} from "./common/_buttonAction";
import {
    headerFunc,
} from "./common/_header";
import {
    headerResize,
} from "./common/_header";
import {
    footerFunc
} from "./common/_footer";
import {
    commonFunc
} from "./common/_common";
import {
    homeFunc
} from "./pages/_home";

$(window).on('load', function () {
    commonFunc();
    headerFunc();
    footerFunc();
    buttonActionFunc();
    homeFunc();
});

$(window).on('load resize', function(){
  headerResize();
});

/**
* 実績スライダー
*/
const achieveSwiper = new Swiper('.achieve-swiper', {
  slidesPerView: 1,
  spaceBetween: 35,
  centeredSlides: true,
  loop: true,
  loopAdditionalSlides: 1,
  speed: 300,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
    waitForTransition: false,
  },
  navigation: {
    nextEl: '.p-print-achieve .swiper-button-next',
    prevEl: '.p-print-achieve .swiper-button-prev',
  },
  breakpoints: {
    980: {
      slidesPerView: 3,
    }
  },
});

// /**
//   * モーダルを開いた時
//   * スクロールを固定
//   */
// function bodyFixedOn() {
//   const $body = $('body');
//   $body.css({
//     overflow: 'hidden',
//   });
// }

// /**
//   * モーダルを開いた時
//   * スクロール固定解除
//   */
// function bodyFixedOff() {
//   const $body = $('body');
//   $body.css({
//     overflow: 'hidden auto',
//   });
// }

// /**
//   * モーダル
//   */
// $('.js-modal').on('click',function() {
//   const modalIndex = $(this).data('index');
//   const modal = $('#' + modalIndex);
//   $(modal).addClass('active');
//   bodyFixedOn();
//   return false;
// });


// /**
//   * モーダルの外側をクリックしたらモーダルを閉じる
//   */
// $(document).on('click',function(e) {
//   if (!$(e.target).closest('.modal-body').length) {
//     $('.modal-background').removeClass('active');
//     bodyFixedOff();
//   }
// });

// /**
//   * 閉じるボタンをクリックしたらモーダルを閉じる
//   */
// $('body').on('click', '.modal-close' ,function(){
//   $('.modal-background').removeClass('active');
//   bodyFixedOff();
// });

// /**
// * モーダルスライダー
// */
// const slideWrap = document.querySelectorAll('.modal-content');
// const slider = document.querySelectorAll('.modal-catalog-swiper');
// for (let i = 0; i < slider.length; i++) {
//   let next = slideWrap[i].querySelector('.swiper-button-next');
//   let prev = slideWrap[i].querySelector('.swiper-button-prev');
//   const mySwiper = new Swiper(slider[i], {
//     slidesPerView: 1,
//     navigation: {
//       nextEl: next,
//       prevEl: prev,
//     },
//   });
// }